export default __webpack_public_path__ + "static/media/12.badb9dab.png";